/* global angular */

angular.module('updateOnEnterCmp', [])
  .directive('updateOnEnter', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attrs, ctrl) {
        element.on('keyup', function (ev) {
          if (ev.keyCode === 13) {
            if (!navigator.userAgent.match(/Trident\/7\.0/)) {
              // For non MSIE only
              ctrl.$commitViewValue()
              scope.$apply(ctrl.$setTouched)
            }
          }
        })
      }
    }
  })
